import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import { graphql } from 'react-relay';
import {
  fetchQuery,
  PreloadedQuery,
  PreloadFetchPolicy,
  usePreloadedQuery,
  useQueryLoader,
  useRelayEnvironment,
} from 'react-relay/hooks';

import Query, { pagesLangingQuery as QueryType } from '@/__generated__/pagesLangingQuery.graphql';
import logger, { logUserId } from '@/common/logger';

type Props = { queryRef: PreloadedQuery<QueryType>; refresh: () => Promise<void> };
function HomePage({ queryRef }: Props) {
  const data = usePreloadedQuery(
    graphql`
      query pagesLangingQuery {
        me {
          id
          confirmed
          teams {
            id
          }
          ...userContext_user
        }
      }
    `,
    queryRef,
  );

  useEffect(() => {
    logUserId(data?.me.id);
  }, [data?.me.id]);

  const router = useRouter();
  useEffect(() => {
    const [team] = data?.me.teams || [];
    if (team) {
      router.push(`/gold/team/${team.id}/project`);
    } else {
      router.push('/gold/account');
    }
  }, [router, data]);

  return null;
}

const ConnectedPage = () => {
  const environment = useRelayEnvironment();
  const [queryRef, loadQuery] = useQueryLoader<QueryType>(Query);

  useEffect(() => {
    loadQuery({});
  }, []);

  const refresh = useCallback(async () => {
    try {
      await fetchQuery(environment, Query, {}).toPromise();
      loadQuery({}, { fetchPolicy: 'store-only' as PreloadFetchPolicy });
    } catch (err) {
      logger.error({ err }, 'Failed to refresh project app query');
    }
  }, []);

  return queryRef ? <HomePage queryRef={queryRef} refresh={refresh} /> : null;
};

// export async function getServerSideProps(ctx: GetServerSidePropsContext) {
//   if (!getAuthStatus(ctx.req).isAuthenticated()) {
//     return {
//       redirect: {
//         destination: `/auth/login?redirectUrl=${encodeURIComponent(ctx.resolvedUrl)}`,
//         permanent: false,
//       },
//     };
//   }
//
//   const environment = initEnvironment(undefined, ctx.req.headers.cookie);
//   const queryProps = await fetchQuery<QueryType>(environment, Query, {}).toPromise();
//
//   if (queryProps && !queryProps.me.confirmed) {
//     return {
//       redirect: {
//         destination: `/registration?redirectUrl=${encodeURIComponent(ctx.resolvedUrl)}`,
//         permanent: false,
//       },
//     };
//   }
//
//   const initialRecords = environment.getStore().getSource().toJSON();
//
//   return { props: { ...queryProps, initialRecords } };
// }

export default ConnectedPage;
